import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "../../../components/common/Loader";
import ApiCalling from "../../../network/ApiCalling";
import Util from "../../../Util";
import { Modal, Button } from "react-bootstrap";
import Close from "../../../assets/Icon/close.png";
import { ModalContent } from "semantic-ui-react";
import Invalid from "../../../assets/Icon/invalid.svg";
import ToastHOC from "../../HOC/ToastHOC";
import Sort from "../../../assets/Icon/Short.svg";
import ModalComponent from "../ModalComponent";

const LeadSources = (props) => {
  const { t } = useTranslation();
  const { setIsToast } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [typeList, setTypeList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [type, setType] = useState("");
  const [typeError, setTypeError] = useState("");
  const [editValue, setEditValue] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [isClickedOnce, setIsClickedOnce] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [sortColumn, setSortColumn] = useState("type");
  const [sortDirection, setSortDirection] = useState("asc");

  const handleSort = (columnName) => {
    setSortColumn(columnName);
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
  };

  const sortedTypeList = [...typeList].sort((a, b) => {
    if (sortColumn === "type") {
      return sortDirection === "asc"
        ? a.type.localeCompare(b.type)
        : b.type.localeCompare(a.type);
    }
    return 0;
  });

  const handleAdd = () => {
    setShowModal(true);
    setEditValue(null);
    setType("");
    setTypeError("");
  };

  const handleClose = () => {
    setShowModal(false);
    setEditValue(null);
    setType("");
    setTypeError("");
  };

  const getTypeList = () => {
    setIsLoading(true);
    ApiCalling.apiCallParamsGet("lead_sources/list")
      .then((res) => {
        setTypeList(res?.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getTypeList();
  }, []);

  const handleSaveAndClose = () => {
    setTypeError("");
    let error = false;
    if (type === "") {
      setTypeError(t("Type is required"));
      error = true;
    }

    if (!error) {
      if (isClickedOnce) {
        return;
      }
      setIsClickedOnce(true);
      setIsLoading(true);
      if (editValue !== null) {
        const data = {
          id: editValue.id,
          type: type,
        };

        ApiCalling.apiCallBodyDataPost("lead_sources/update", data)
          .then((res) => {
            if (res.data.status === true) {
              setShowModal(false);
              setIsLoading(false);
              setIsToast(res.data.message);

              getTypeList();
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      } else {
        const data = {
          type: type,
        };
        ApiCalling.apiCallBodyDataPost("lead_sources/add", data)
          .then((res) => {
            if (res.data.status === true) {
              setShowModal(false);
              setIsLoading(false);
              setIsToast(res.data.message);

              getTypeList();
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      }
    }
  };

  const handleDelete = () => {
    setIsLoading(true);
    ApiCalling.apiCallDelete(`lead_sources/${deleteId}`)
      .then((res) => {
        if(res.data.status){
          setIsLoading(false);
          setIsToast(t("Lead source Deleted Successfully"));
          setShowDeleteConfirmation(false);
          getTypeList();
        }else{
          setIsLoading(false);
          setShowDeleteConfirmation(false);
          setIsToast(res?.data?.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="header text-right px-0 mb-2">
            <button
              className="btn custom-primary"
              type="button"
              aria-expanded="false"
              style={{ color: "#fff", padding: "5px, 10px" }}
              onClick={handleAdd}
            >
              {t("Add Lead Sources")}
            </button>
          </div>
        </div>

        <Modal
          show={showModal}
          onHide={handleClose}
          animation={true}
          centered={true}
          dialogClassName="modal-view"
          onShow={() => {
            setIsClickedOnce(false);
            if (editValue !== null) {
              setType(editValue.type);
            }
          }}
        >
          <div className="d-flex justify-content-between align-items center p-4 border-bottom">
            <h6>
              {editValue !== null
                ? t("Edit Lead sources")
                : t("Add Lead sources")}
            </h6>

            <button className="hidden-btn" onClick={handleClose}>
              <img src={Close} className="svg-icon" height={20} width={20} />
            </button>
          </div>
          <ModalContent isLoading={isLoading}>
            <Modal.Body>
              <div className="form-group text-start">
                <label className="basic-text required">
                  {t("Enquiry Status")}
                </label>
                <input
                  className={`form-control ${
                    typeError.length > 0 ? "input-error" : "custom-input"
                  }`}
                  placeholder={t("Enter Type")}
                  type="text"
                  value={type}
                  onChange={(event) => {
                    setType(event.target.value);
                    setTypeError("");
                  }}
                />
                {typeError.length > 0 && (
                  <span className="text-danger invalid-error">
                    <img
                      className="fa fa-exclamation-circle mr-2 invalid-svg"
                      src={Invalid}
                    />
                    {typeError}
                  </span>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn custom-primary"
                onClick={handleSaveAndClose}
              >
                {t("Save")}
              </Button>
            </Modal.Footer>
          </ModalContent>
        </Modal>

        <div className="row clearfix ">
          <div className="table-div overflow-hidden mt-2 p-0">
            <div className="col-lg-12 col-md-12 p-0 m-0">
              <div className="body">
                <>
                  {!isLoading ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">
                            {t("Type")}{" "}
                            <img
                              src={Sort}
                              className="ml-1 fa-sort"
                              alt=""
                              onClick={() => {
                                handleSort("type");
                              }}
                            />
                          </th>
                          <th scope="col"></th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      {typeList.length > 0 ? (
                        <tbody>
                          {sortedTypeList.map((t, index) => {
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{t?.type}</td>
                                <td>
                                  <a
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setEditValue(t);
                                      setShowModal(true);
                                    }}
                                    className={`${
                                      !Util.hasPermission("MASTERS_EDIT") &&
                                      "no-permission"
                                    }`}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </a>
                                </td>
                                <td>
                                  <a
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setShowDeleteConfirmation(true);
                                      setDeleteId(t.id);
                                    }}
                                    className={`${
                                      Util.hasPermission("MASTERS_DELETE")
                                        ? "pl-5"
                                        : "no-permission"
                                    }`}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fa fa-trash-o text-danger"></i>
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      ) : (
                        <tfoot>
                          <tr>
                            <td colSpan={4}>
                              {t(
                                "There are no Observation. Click the 'Add Observation ' button to create one."
                              )}
                            </td>
                          </tr>
                        </tfoot>
                      )}
                    </table>
                  ) : (
                    <Loader />
                  )}
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        show={showDeleteConfirmation}
        onHide={() => {
          setShowDeleteConfirmation(false);
        }}
        title={t("Delete")}
        onCancel={t("Cancel")}
        onConfirm={t("Confirm")}
        subTitle={t("Are you sure, to delete this Lead Source?")}
        size="sm"
        onCancelClick={() => {
          setShowDeleteConfirmation(false);
        }}
        onConfirmClick={handleDelete}
      />
    </div>
  );
};

export default ToastHOC(LeadSources);
